import { Controller } from "@hotwired/stimulus"
import { Readability } from "@mozilla/readability"

// Connects to data-controller="reader"
export default class ReaderController extends Controller<HTMLElement> {
  static targets = ["initialContent", "content"]
  static values = {
    url: String,
  }

  declare initialContentTarget: HTMLTemplateElement
  declare contentTarget: HTMLElement
  declare urlValue: string
  declare hasUrlValue: boolean

  connect() {
    const doc = new DOMParser().parseFromString(this.initialContentTarget.innerHTML, "text/html")
    this.#absolutizeDocLinks(doc)
    const article = new Readability(doc).parse()
    if (article && article.content && this.contentTarget) {
      this.contentTarget.innerHTML = article.content
    }
  }

  // Private

  #absolutizeDocLinks(doc: Document) {
    if (!this.hasUrlValue) return

    let base = doc.querySelector("base")
    if (!base) {
      base = doc.createElement("base")
      doc.head.prepend(base)
    }
    base.href = this.urlValue
  }
}
